module.exports = __webpack_public_path__ + "img/amantani.612d99c1.jpg";